import { useQuery } from "@tanstack/react-query";
import { LEAD_TAGS_QUERY_KEY, leadTagsApi } from "api/lead-tags";

const LEAD_TAGS_STALE_TIME_MS = 30_000;

/** The partner's master list of tags, A to Z. Counts are only returned to admins. */
export const useLeadTags = ({
  includeCounts = false,
  enabled = true
}: { includeCounts?: boolean; enabled?: boolean } = {}) =>
  useQuery({
    queryKey: [LEAD_TAGS_QUERY_KEY, includeCounts ? "WITH_COUNTS" : "LIST"],
    queryFn: () => leadTagsApi.list({ includeCounts }),
    enabled,
    staleTime: LEAD_TAGS_STALE_TIME_MS
  });
